import { type MiniGameCardsOptions } from '../types/dice-game';

const generateMiniGameCardsOptions = (): MiniGameCardsOptions => ({
  mainPrize: 5,
  bomb: 1,
  doublePrize: 1,
  empty: 1,
  stop: 1,
});

export { generateMiniGameCardsOptions };
